/************************************  
 * @description: Contains actions used inside reducers
 * and inside other components according to the requirements;
 ************************************/
export const UPDATE_MINS = "UPDATE_MINS"
export const UPDATE_SEC = "UPDATE_SECODS"
export const RESET_SEC = "RESET_SECONDS"
export const STOP_TIMER = "STOP_TIMER"
export const START_SB = "START_SMALL_BREAK";
export const STOP_SB = "STOP_SMALL_BREAK";
export const START_LB = "START_LONG_BREAK";
export const STOP_LB = "STOP_LONG_BREAK";
export const LOAD_INI = "LOAD_INITAIL_DATA";
export const TIMER_RUNSTATUS = "TIMER_RUN_STATUS"
export const UPDATETIMERSELECTION = "UPDATE_TIMER_SELECTION"
export const RESET_TIMER = "RESET_TIMER"
export const ADD_TASK = "ADD_TASK"
export const REMOVE_TASK = "REMOVE_TASK"
export const UPDATE_TASK = "UPDATE_TASK"
